import { CircularProgress } from "@mui/material";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Suspense fallback={<CircularProgress />}>
    <App />
  </Suspense>
);
